import { consoleLogger } from '../logging/consoleLogger';
import { getStubToken } from '@shared/helpers/stubToken';

const getStubTokenQueryString = () => {
  const stubToken = getStubToken();
  return stubToken ? `&x-cryptip=${stubToken}` : '';
};

export const getUrlWithTransactionId = (url: string) => {
  const transactionId = window.Utiq?.transactionId;
  if (transactionId) {
    const transactionIdSeparator = url.includes('?') ? '&' : '?';
    return `${url}${transactionIdSeparator}transactionId=${transactionId}${getStubTokenQueryString()}`;
  }

  consoleLogger.logDebug(
    `No transactionId found in Utiq namespace. Returning original URL...`,
  );
  return url;
};
